import { ApiClientFactory } from "common/middleware/api.client-factory";
import { EditBrokerAccountCommand, IEditBrokerAccountCommand } from "common/middleware/api.services";
import { Logger } from "common/middleware/logger";
import { mutateLoggedInUser } from "common/middleware/hooks";

export const editBrokerProfile = async (values: IEditBrokerAccountCommand) => {
  Logger.debug("Editing broker profile");

  const client = await ApiClientFactory.getAccountsClient();

  const res = await client.editBroker(EditBrokerAccountCommand.fromJS(values));

  mutateLoggedInUser();

  return res;
}
